/* Serial Seal — sports motif pack.
 * Extends SS_ART.motif in place. Drawn with SS_ART's own helpers so every
 * motif obeys the material rule: ink is painted AROUND the shine, the holes
 * punched through an inked field ARE the live holographic foil.
 *
 * Original heraldry and generic objects only — a pennant, a shirt, a cup, a
 * seam, a bowl, a stub. Nothing here evokes a league, a club or a maker, and
 * no motif carries a wordmark or a numeral: every name plate, number panel and
 * seat block is a BLANK foil field. That is both the safe answer and the
 * strongest thing available on this stock.
 */
(function () {
  'use strict';
  var A = window.SS_ART;
  if (!A) return;

  var INK = A.INK, INK2 = A.INK2, INK3 = A.INK3, L1 = A.L1, L2 = A.L2;
  var r2 = A.r2, cut = A.cut, rng = A.rng, circPath = A.circPath;

  /* ss-art.js redeclares these inside each motif. Six motifs is where that
     stops being cheap — one definition means one place for a rounding bug to
     live, and the packs are meant to draw with identical primitives. */
  function bar(x, y, w, h) {
    return 'M' + r2(x) + ' ' + r2(y) + 'h' + r2(w) + 'v' + r2(h) + 'h' + r2(-w) + 'Z';
  }
  function rr(x, y, w, h, r) {
    return 'M' + r2(x + r) + ' ' + r2(y) + 'h' + r2(w - r * 2) +
      'a' + r + ' ' + r + ' 0 0 1 ' + r + ' ' + r + 'v' + r2(h - r * 2) +
      'a' + r + ' ' + r + ' 0 0 1 ' + (-r) + ' ' + r + 'h' + r2(-(w - r * 2)) +
      'a' + r + ' ' + r + ' 0 0 1 ' + (-r) + ' ' + (-r) + 'v' + r2(-(h - r * 2)) +
      'a' + r + ' ' + r + ' 0 0 1 ' + r + ' ' + (-r) + 'Z';
  }
  function ell(cx, cy, rx, ry) {
    return 'M' + r2(cx - rx) + ' ' + r2(cy) + 'a' + r2(rx) + ' ' + r2(ry) + ' 0 1 0 ' +
      r2(rx * 2) + ' 0a' + r2(rx) + ' ' + r2(ry) + ' 0 1 0 ' + r2(-rx * 2) + ' 0Z';
  }
  /* a foil keyline ring — outer bar and inner bar, read together by evenodd */
  function frame(x, y, w, h, t) {
    return bar(x, y, w, h) + ' ' + bar(x + t, y + t, w - t * 2, h - t * 2);
  }

  /* ——————— SPORTS-COLLECTIBLE MOTIFS ———————
     Added 2026-08-01 to sit beside the card set. Same discipline: the subject
     is bare foil, the ink is only the ground it is cut out of. */

  /* team pennant — a tapering triangle on a turned staff, streamers trailing
     off the hoist. The hoist strip and the long name field are punched clean
     through the flag body, so the two places a club would print its identity
     are the two places that blaze. */
  A.motif.pennant = function (seed) {
    var rnd = rng(seed || 'pennant'), o = '', i, t;
    var HX = 15, TX = 94, CY = 51, HH = 30;        // hoist x, tip x, centre line, half-height
    function edge(x, s) { return r2(CY + s * HH * (TX - x) / (TX - HX)); }

    var flag = 'M15 21L94 51L15 81Z';
    /* staff and finial only KISS — two holes that overlap would cancel each
       other under evenodd and print as a solid black bar */
    var staff = bar(8.5, 11.5, 6.3, 100.5);
    var finial = circPath(11.65, 7, 4.5);
    o += cut([finial, staff, flag], INK, 0.42);

    /* flag body inked inside the foil silhouette, hoist strip and name field
       punched straight back out of it */
    o += '<path fill-rule="evenodd" fill="' + INK + '" d="M19.5 26.4L88 51L19.5 75.6Z ' +
      'M22.5 30.1L27 31.7V70.3L22.5 71.9Z ' +
      'M31 42.5L77 48.2V53.8L31 59.5Z ' +
      'M79.5 48.9L85 51L79.5 53.1Z"/>';                // tip pip, so the tail is not dead ink
    o += '<path d="' + flag + '" fill="none" stroke="{{color_hex}}" stroke-width="1.5"/>';
    o += '<path d="M31 61.4L77 55" stroke="{{color_hex}}" stroke-width="1.1" opacity="0.9"/>';

    o += '<circle cx="24.75" cy="38" r="1.5" fill="' + INK + '"/>';   // grommets, ink on shine
    o += '<circle cx="24.75" cy="64" r="1.5" fill="' + INK + '"/>';
    o += '<path d="M21 29.6L85 50.3M21 72.4L85 51.7" fill="none" stroke="' + L2 +
      '" stroke-width="0.6" opacity="0.6"/>';                          // stitched hem

    /* pole: ink shaft with one foil pinstripe, finial ring with a foil pip */
    o += '<path fill-rule="evenodd" fill="' + INK + '" d="' + bar(9.8, 13, 3.7, 97.5) +
      ' ' + bar(11.15, 17, 1.1, 89) + '"/>';
    o += '<path fill-rule="evenodd" fill="' + INK + '" d="' + circPath(11.65, 7, 3.2) +
      ' ' + circPath(11.65, 7, 1.4) + '"/>';
    /* the pole stands in a socket block, its slot cut back to foil */
    o += '<path fill-rule="evenodd" fill="' + INK + '" d="' + bar(3.5, 103, 17.5, 9) +
      ' ' + bar(6, 106, 12.5, 2.6) + '"/>';

    /* wind: thin arcs raked back over the flag so it reads as flying */
    for (i = 0; i < 3; i++) {
      t = 7.5 + i * 5.2;
      o += '<path d="M21 ' + r2(t) + 'Q54 ' + r2(t - 4) + ' 93 ' + r2(t + 9.5) +
        '" fill="none" stroke="' + INK + '" stroke-width="' + (i === 1 ? 1.1 : 0.7) +
        '" opacity="0.42"/>';
    }

    /* two streamers off the hoist, drawn as PAIRS of ink rules — the gap inside
       each pair stays bare foil. A filled ribbon is just a black worm. The two
       spines never cross: crossed streamers read as tangled wire, not cloth. */
    [[79, 9, -7, 6], [90, 12, -4, 12]].forEach(function (rb) {
      for (t = -1; t <= 1; t += 2) {
        var y0 = rb[0], w = t * 3.6;
        o += '<path d="M20 ' + r2(y0 + w) + 'C38 ' + r2(y0 + rb[1] + w) + ' 54 ' + r2(y0 + rb[2] + w) +
          ' 72 ' + r2(y0 + rb[3] + w) + 'S94 ' + r2(y0 + rb[3] * 3 + w) + ' 100 ' +
          r2(y0 + rb[3] * 4 + w) + '" fill="none" stroke="' + INK + '" stroke-width="2"/>';
      }
    });
    /* the wrap that ties them to the hoist, its band cut back to foil */
    o += '<path fill-rule="evenodd" fill="' + INK + '" d="' + bar(17.4, 74, 5.6, 21) +
      ' ' + bar(18.8, 79, 2.8, 11) + '"/>';

    for (i = 0; i < 10; i++) {                     // strike sparkle in the smoked field
      o += '<circle cx="' + r2(28 + rnd() * 66) + '" cy="' + r2(88 + rnd() * 26) +
        '" r="' + r2(0.6 + rnd() * 0.9) + '" fill="' + L1 + '" opacity="' + r2(0.3 + rnd() * 0.35) + '"/>';
    }
    return o;
  };

  /* hanging jersey — shoulders, sleeves, a hem band and a number panel that
     takes up most of the torso. The number itself is never drawn: the panel is
     a hole, so the "number" is whatever the foil is doing when you tilt it. */
  A.motif.jersey = function (seed) {
    var rnd = rng(seed || 'jersey'), o = '', i;

    var tee = 'M26 18L38 12.6Q50 9.4 62 12.6L74 18L92 32L84 48L76 42V99H24V42L16 48L8 32Z';
    var rail = bar(6, 4, 88, 4.2);
    o += cut([rail, tee], INK, 0.4);

    /* the shirt inked inside its own foil silhouette. Every hole below is a
       separate island — none may touch another or evenodd flips it back to ink. */
    var holes = [];
    holes.push('M40 16.4Q50 13.6 60 16.4Q56.5 25 50 25Q43.5 25 40 16.4Z');   // collar
    holes.push(bar(34, 34, 32, 5.6));                                        // name plate
    holes.push(rr(32, 44, 36, 42, 3.5));                                     // NUMBER PANEL
    holes.push(bar(28.5, 46, 2.6, 40));                                      // side stripes
    holes.push(bar(69.4, 46, 2.6, 40));
    holes.push(bar(27.8, 89, 44.4, 4.4));                                    // hem band
    holes.push('M13.87 33.97L19.43 43.97L23.45 41.74L17.89 31.74Z');         // cuffs
    holes.push('M86.13 33.97L80.57 43.97L76.55 41.74L82.11 31.74Z');
    o += '<path fill-rule="evenodd" fill="' + INK +
      '" d="M28.5 20.5L39.5 15.4Q50 12.6 60.5 15.4L71.5 20.5L88.5 33L81 46.5L73 41.5V96H27V41.5L19 46.5L11.5 33Z ' +
      holes.join(' ') + '"/>';

    o += '<path d="' + tee + '" fill="none" stroke="{{color_hex}}" stroke-width="1.5"/>';
    o += '<path d="' + rr(32, 44, 36, 42, 3.5) + '" fill="none" stroke="{{color_hex}}" stroke-width="1.2"/>';

    /* the panel stays bare — only corner ticks land on it, the way a print shop
       marks a placement box */
    [[34.5, 46.5, 1, 1], [65.5, 46.5, -1, 1], [34.5, 83.5, 1, -1], [65.5, 83.5, -1, -1]].forEach(function (c) {
      o += '<path d="M' + c[0] + ' ' + r2(c[1] + c[3] * 5) + 'V' + c[1] + 'H' + r2(c[0] + c[2] * 5) +
        '" fill="none" stroke="' + INK + '" stroke-width="1.3"/>';
    });

    o += '<path d="M41.5 18.4Q50 16.2 58.5 18.4" fill="none" stroke="' + INK +
      '" stroke-width="1.2"/>';                                              // collar rib
    o += '<path d="M29 21.5L40.5 16.8M71 21.5L59.5 16.8" stroke="' + L2 +
      '" stroke-width="0.6" stroke-dasharray="2 1.8" opacity="0.8"/>';       // shoulder seams
    for (i = 0; i < 3; i++) {                                                // sleeve hatching
      o += '<path d="M' + r2(15.5 + i * 2.6) + ' ' + r2(30.5 + i * 1.3) + 'L' + r2(23 + i * 2.6) +
        ' ' + r2(24 + i * 1.3) + 'M' + r2(84.5 - i * 2.6) + ' ' + r2(30.5 + i * 1.3) + 'L' +
        r2(77 - i * 2.6) + ' ' + r2(24 + i * 1.3) + '" stroke="' + INK +
        '" stroke-width="0.8" opacity="0.75"/>';
    }
    for (i = 0; i < 3; i++) {                                                // cloth falling in folds
      var fx = 30 + i * 20;
      o += '<path d="M' + r2(fx) + ' 48Q' + r2(fx + 3) + ' 70 ' + r2(fx - 1) + ' 92" fill="none" stroke="' +
        L2 + '" stroke-width="0.55" opacity="0.32"/>';
    }
    o += '<path d="M31 91.2h6M63 91.2h6" stroke="' + INK + '" stroke-width="1.1"/>';

    /* rail and hook — the shirt is hanging, so something has to hold it */
    o += '<path d="M8 6.1h84" stroke="' + INK + '" stroke-width="0.9" opacity="0.8"/>';
    o += '<path d="M50 15V9.4a3.4 3.4 0 0 1 6.4-1.2" fill="none" stroke="' + INK + '" stroke-width="2"/>';

    /* plinth banner, its plate slots cut to foil */
    o += '<path fill-rule="evenodd" fill="' + INK + '" d="M8 103h84l-6 6 6 6H8l6-6Z ' +
      'M22 107.4h30v3h-30Z M56 107.4h18v3h-18Z"/>';
    o += '<path d="M13 105h74" stroke="' + L2 + '" stroke-width="0.7" opacity="0.75"/>';

    for (i = 0; i < 9; i++) {
      o += '<circle cx="' + r2(rnd() * 100) + '" cy="' + r2(48 + rnd() * 52) + '" r="' +
        r2(0.5 + rnd() * 0.8) + '" fill="' + L1 + '" opacity="' + r2(0.25 + rnd() * 0.3) + '"/>';
    }
    return o;
  };

  /* championship cup — two-handled, centred, standing on a stepped plinth with
     laurel either side. Deliberately NOT ss-art's `crest`: no shield, the cup
     owns the window and the plinth carries the blank plate instead of a banner
     doing all the work. */
  A.motif.trophycup = function (seed) {
    var rnd = rng(seed || 'trophycup'), o = '', i, s;

    var bowl = 'M30.4 28.6C30.4 50 38 60.5 45 64H55C62 60.5 69.6 50 69.6 28.6Z';
    /* handles are crescents that stop just short of the bowl — 0.6 of smoked
       field between them reads as a shadow line and keeps evenodd honest */
    var handL = 'M28.5 28.8C19 31.5 19 47 33.6 49.8L32 45.4C24.5 43.6 24.5 34 28.8 33.2Z';
    var handR = 'M71.5 28.8C81 31.5 81 47 66.4 49.8L68 45.4C75.5 43.6 75.5 34 71.2 33.2Z';

    o += cut([bar(27, 21, 46, 6.5), bowl, handL, handR,
      bar(45.6, 64.3, 8.8, 7.7), bar(40, 72.4, 20, 4),
      'M36 76.8h28l4 6.2h-36Z', bar(30, 83.6, 40, 7.4), bar(23, 91.5, 54, 9),
      'M10 102h80l-6 6.5 6 6.5H10l6-6.5Z'], INK, 0.44);

    /* ceremonial rays. They start at r=46 — outside everything the cup owns —
       because the cup is a HOLE: paint a fan from the centre and it lands on the
       foil inside the bowl as a black starburst instead of behind it. */
    for (i = 0; i < 15; i++) {
      var a = -Math.PI / 2 + (i - 7) * 0.19, ca = Math.cos(a), sa2 = Math.sin(a);
      o += '<path d="M' + r2(50 + ca * 46) + ' ' + r2(58 + sa2 * 46) + 'L' + r2(50 + ca * 115) +
        ' ' + r2(58 + sa2 * 115) + '" stroke="' + INK + '" stroke-width="' +
        (i % 2 ? 0.55 : 1.1) + '" opacity="0.26"/>';
    }

    /* laurel sprays flanking the plinth. Leaves alternate to either side of the
       stem at 7.2 pitch — packed any tighter they merge into one black sausage. */
    for (s = -1; s <= 1; s += 2) {
      var stem = 'M' + r2(50 + s * 33) + ' 94Q' + r2(50 + s * 38.5) + ' 70 ' + r2(50 + s * 31) + ' 44';
      o += '<path d="' + stem + '" fill="none" stroke="' + INK + '" stroke-width="1.4" opacity="0.9"/>';
      for (i = 0; i < 8; i++) {
        var ly = 92 - i * 7.2, lx = 50 + s * (35.5 - i * 0.4 + (i % 2 ? 2.6 : -2.6));
        var deg = s > 0 ? -36 - i * 2.5 : 216 + i * 2.5;
        o += '<ellipse cx="' + r2(lx) + '" cy="' + r2(ly) + '" rx="4.6" ry="2.1" fill="' +
          (i % 3 ? INK : INK2) + '" transform="rotate(' + r2(deg) + ' ' + r2(lx) + ' ' + r2(ly) + ')"/>';
      }
    }

    /* struck star above the cup — an ink lozenge with an eight-point foil star
       punched out of it. Kept faceted, never a banded sphere. */
    var star = '', st;
    for (i = 0; i < 16; i++) {
      st = -Math.PI / 2 + i * Math.PI / 8;
      star += (i ? 'L' : 'M') + r2(50 + Math.cos(st) * (i % 2 ? 2.4 : 6.2)) + ' ' +
        r2(12 + Math.sin(st) * (i % 2 ? 2.4 : 6.2));
    }
    o += '<path fill-rule="evenodd" fill="' + INK + '" d="M50 2.6L59.4 12L50 21.4L40.6 12Z ' + star + 'Z"/>';

    /* rim beads, then flutes running down the bowl */
    for (i = 0; i < 12; i++) {
      o += '<path d="' + bar(28.6 + i * 3.7, 22.4, 1.9, 3.7) + '" fill="' + INK + '" opacity="0.9"/>';
    }
    /* the bowl is modelled by DARKENING ITS WALLS, not by ruling flutes down it:
       every flute converges on the foot and the fan prints as a black claw. Two
       crescents hugging the walls leave the belly of the cup bare foil. */
    o += '<path d="M30.4 28.6C30.4 50 38 60.5 45 64H49.2C42.2 60.5 34.6 50 34.6 28.6Z" fill="' +
      INK + '" opacity="0.34"/>';
    o += '<path d="M69.6 28.6C69.6 50 62 60.5 55 64H50.8C57.8 60.5 65.4 50 65.4 28.6Z" fill="' +
      INK + '" opacity="0.34"/>';
    o += '<path d="M31.6 30.4Q50 36 68.4 30.4" fill="none" stroke="' + INK +
      '" stroke-width="1.1" opacity="0.85"/>';                  // the mouth, seen slightly above
    /* keyline the handles or they merge with the bowl into one pale blob */
    o += '<path d="' + handL + ' ' + handR + '" fill="none" stroke="' + INK + '" stroke-width="1"/>';
    /* engraved band across the bowl, its two plate slots cut back to foil */
    o += '<path fill-rule="evenodd" fill="' + INK + '" d="' + bar(32.8, 35, 34.4, 6.5) +
      ' ' + bar(36, 36.8, 12, 2.9) + ' ' + bar(52, 36.8, 12, 2.9) + '"/>';
    o += '<path d="' + bowl + '" fill="none" stroke="{{color_hex}}" stroke-width="1.5"/>';

    o += '<path d="M45.6 66.5h8.8M45.6 69.8h8.8" stroke="' + INK + '" stroke-width="1"/>';
    o += '<path d="M41 74.4h18" stroke="' + INK + '" stroke-width="1.1"/>';
    o += '<path d="M36.5 79.8h27" stroke="' + INK + '" stroke-width="0.9" opacity="0.85"/>';
    o += '<path d="M32 87.2h36" stroke="' + INK + '" stroke-width="0.9" opacity="0.85"/>';

    /* dedication plate on the lower step: ink block with the "engraving" cut out */
    o += '<path fill-rule="evenodd" fill="' + INK + '" d="' + rr(27.5, 93.2, 45, 5.8, 1) +
      ' ' + bar(30.5, 95, 24, 2.2) + ' ' + bar(57.5, 95, 11, 2.2) + '"/>';
    o += '<path d="M14 105.4h72" stroke="{{color_hex}}" stroke-width="1.2" opacity="0.9"/>';
    o += '<path d="M20 110.6h26v2.2h-26Z M50 110.6h16v2.2h-16Z" fill="' + INK + '"/>';

    for (i = 0; i < 11; i++) {
      var sa = rnd() * Math.PI * 2, sr = 30 + rnd() * 28;
      o += '<circle cx="' + r2(50 + Math.cos(sa) * sr) + '" cy="' + r2(44 + Math.sin(sa) * sr * 0.8) +
        '" r="' + r2(0.55 + rnd() * 0.9) + '" fill="' + L1 + '" opacity="' + r2(0.3 + rnd() * 0.35) + '"/>';
    }
    return o;
  };

  /* ball seam — the window is a close crop of the leather, so both seams run
     clean off every edge. The seam CHANNELS are cut to foil and the stitches
     are inked across them: the brightest thing on the seal is the join. */
  A.motif.stitching = function (seed) {
    var rnd = rng(seed || 'stitching'), o = '', i, k;

    var arcs = [
      [[6, -8], [44, 24], [44, 70], [8, 124]],
      [[94, -8], [56, 24], [56, 70], [92, 124]]
    ];
    function bez(p, t) {
      var u = 1 - t, a = u * u * u, b = 3 * u * u * t, c = 3 * u * t * t, d = t * t * t;
      return [p[0][0] * a + p[1][0] * b + p[2][0] * c + p[3][0] * d,
              p[0][1] * a + p[1][1] * b + p[2][1] * c + p[3][1] * d];
    }
    function dbez(p, t) {
      var u = 1 - t, a = 3 * u * u, b = 6 * u * t, c = 3 * t * t;
      return [a * (p[1][0] - p[0][0]) + b * (p[2][0] - p[1][0]) + c * (p[3][0] - p[2][0]),
              a * (p[1][1] - p[0][1]) + b * (p[2][1] - p[1][1]) + c * (p[3][1] - p[2][1])];
    }
    /* the curves are near vertical over the whole window, so shifting the
       control points in x is a faithful enough normal offset — and it lets the
       return side be the SAME cubic with its ends swapped */
    function fwd(p, dx) {
      return 'M' + r2(p[0][0] + dx) + ' ' + p[0][1] + 'C' + r2(p[1][0] + dx) + ' ' + p[1][1] +
        ' ' + r2(p[2][0] + dx) + ' ' + p[2][1] + ' ' + r2(p[3][0] + dx) + ' ' + p[3][1];
    }
    function channel(p, w) {
      /* the return side is the same cubic with its ends swapped, which is
         exactly a reversed traversal — no second curve to keep in sync */
      return fwd(p, -w) + 'L' + r2(p[3][0] + w) + ' ' + p[3][1] +
        'C' + r2(p[2][0] + w) + ' ' + p[2][1] + ' ' + r2(p[1][0] + w) + ' ' + p[1][1] +
        ' ' + r2(p[0][0] + w) + ' ' + p[0][1] + 'Z';
    }

    var holes = [channel(arcs[0], 3.4), channel(arcs[1], 3.4)];
    /* grain highlights, confined to the corridor BETWEEN the seams — a speck
       straddling a channel is another hole in the same evenodd path, so the
       overlap flips back to ink and bites a black notch out of the brightest
       thing on the seal. Each box clears the widest excursion of both channels
       (incl. the 3.4 half-width) by >1.5, which is the largest speck radius. */
    var safe = [[41, 24, 19, 68], [51, 3, 14, 20], [35, 3, 14, 20], [32, 93, 20, 20]];
    for (i = 0; i < 14; i++) {
      var b = safe[i % 4];
      holes.push(circPath(r2(b[0] + rnd() * b[2]), r2(b[1] + rnd() * b[3]), r2(0.6 + rnd() * 0.9)));
    }
    o += cut(holes, INK, 0.5);

    /* corner shading so the crop reads as curving away from you — kept small and
       faint, since four big wedges leave a diamond in the middle by accident */
    [[0, 0, 1, 1], [100, 0, -1, 1], [0, 117, 1, -1], [100, 117, -1, -1]].forEach(function (c) {
      o += '<path d="M' + c[0] + ' ' + c[1] + 'l' + r2(c[2] * 27) + ' 0l' + r2(-c[2] * 27) + ' ' +
        r2(c[3] * 30) + 'Z" fill="' + INK + '" opacity="0.15"/>';
    });

    /* paired stitches straddling each channel — same tangential rake on both
       sides, so each pair closes into a chevron pointing along the seam */
    for (k = 0; k < 2; k++) {
      for (i = 0; i <= 26; i++) {
        var t = i / 26, pt = bez(arcs[k], t), d = dbez(arcs[k], t);
        var m = Math.sqrt(d[0] * d[0] + d[1] * d[1]);
        var ux = d[0] / m, uy = d[1] / m, nx = -uy, ny = ux;
        for (var sgn = -1; sgn <= 1; sgn += 2) {
          o += '<path d="M' + r2(pt[0] + nx * sgn * 1.5 + ux * 3.1) + ' ' +
            r2(pt[1] + ny * sgn * 1.5 + uy * 3.1) + 'L' +
            r2(pt[0] + nx * sgn * 6.8 - ux * 1.5) + ' ' + r2(pt[1] + ny * sgn * 6.8 - uy * 1.5) +
            '" stroke="' + INK + '" stroke-width="1.5" stroke-linecap="round"/>';
        }
      }
      o += '<path d="' + fwd(arcs[k], 0) +
        '" fill="none" stroke="{{color_hex}}" stroke-width="1" opacity="0.9"/>';
    }

    /* leather pebbling — sparse ink dots, kept inside the same corridor boxes.
       Widening them here put dots straight onto the lit seam and its accent
       rule, which is mud, not grain. */
    for (i = 0; i < 44; i++) {
      var g = safe[i % 4];
      o += '<circle cx="' + r2(g[0] + rnd() * g[2]) + '" cy="' + r2(g[1] + rnd() * g[3]) +
        '" r="' + r2(0.45 + rnd() * 0.85) + '" fill="' + INK3 + '" opacity="' + r2(0.4 + rnd() * 0.45) + '"/>';
    }
    for (i = 0; i < 12; i++) {
      var q = safe[i % 4];
      o += '<circle cx="' + r2(q[0] + rnd() * q[2]) + '" cy="' + r2(q[1] + rnd() * q[3]) + '" r="' +
        r2(0.5 + rnd() * 0.8) + '" fill="' + L1 + '" opacity="' + r2(0.25 + rnd() * 0.35) + '"/>';
    }
    return o;
  };

  /* stadium bowl under floodlights — the pitch is one clean foil ellipse, the
     tiers are ink bands laid ON that foil so the gaps between them shine, and
     the light shafts are wedges cut out of the night sky. */
  A.motif.stadium = function (seed) {
    var rnd = rng(seed || 'stadium'), o = '', i;
    var CX = 50, CY = 79, PRX = 23, PRY = 13.5, ORX = 47, ORY = 32;
    var masts = [11, 37, 63, 89], shafts = [-1.6, -0.7, 0.7, 1.6];

    function ring(s) { return ell(CX, CY, PRX + s * (ORX - PRX), PRY + s * (ORY - PRY)); }
    function pt(s, a) {
      return r2(CX + Math.cos(a) * (PRX + s * (ORX - PRX))) + ' ' +
        r2(CY + Math.sin(a) * (PRY + s * (ORY - PRY)));
    }

    var holes = [ell(CX, CY, ORX, ORY)];                 // the whole bowl starts as bare foil
    masts.forEach(function (mx) {                        // four shafts per mast, stopping
      shafts.forEach(function (j) {                      // 1 short of the roof. One solid
        holes.push('M' + r2(mx + j * 3.2 - 1.3) + ' 22L' + // trapezoid reads as a cooling
          r2(mx + j * 6 - 2.6) + ' 46H' + r2(mx + j * 6 + 2.6) + // tower; a splayed fan reads
          'L' + r2(mx + j * 3.2 + 1.3) + ' 22Z');          // as light.
      });
    });
    [[50, 9], [26, 5], [74, 5], [50, 32], [6, 10], [94, 10]].forEach(function (st) {
      holes.push(circPath(st[0], st[1], 1.5));
    });
    o += cut(holes, INK, 0.5);

    /* tiers: ink annuli painted onto the bright bowl. Drawn as bands rather
       than cut as rings because nested holes inside one evenodd path flip back
       to ink — the gaps between these bands are the foil. */
    [[0.06, 0.26], [0.38, 0.58], [0.70, 0.90]].forEach(function (b, k) {
      var d = ring(b[1]) + ' ' + ring(b[0]);
      if (k === 0) {                                     // vomitory mouths in the lower tier
        for (i = 0; i < 10; i++) {
          var a = (i / 10) * Math.PI * 2 + 0.31;
          d += ' M' + pt(0.10, a - 0.05) + 'L' + pt(0.22, a - 0.05) + 'L' + pt(0.22, a + 0.05) +
            'L' + pt(0.10, a + 0.05) + 'Z';
        }
      }
      o += '<path fill-rule="evenodd" fill="' + (k === 1 ? INK2 : INK) + '" d="' + d + '"/>';
    });

    for (i = 0; i < 18; i++) {                           // stair spokes crossing every tier
      var sa = (i / 18) * Math.PI * 2;
      o += '<path d="M' + pt(0.02, sa) + 'L' + pt(0.99, sa) + '" stroke="' + INK +
        '" stroke-width="' + (i % 3 ? 0.85 : 1.4) + '" opacity="0.9"/>';
    }
    o += '<path d="' + ring(1) + '" fill="none" stroke="{{color_hex}}" stroke-width="1.5"/>';
    o += '<path d="' + ring(1.07) + '" fill="none" stroke="' + L2 + '" stroke-width="0.6" opacity="0.6"/>';

    /* pitch markings kept to hairlines — the pitch has to stay the brightest
       area in the window */
    o += '<path d="' + ell(CX, CY, PRX, PRY) + '" fill="none" stroke="{{color_hex}}" stroke-width="1.3"/>';
    o += '<path d="M50 65.8V92.2" stroke="' + INK + '" stroke-width="0.8" opacity="0.9"/>';
    o += '<path d="' + ell(CX, CY, 5.6, 3.3) + '" fill="none" stroke="' + INK + '" stroke-width="0.8"/>';
    o += '<path d="M30.5 73.6h5.4v10.8h-5.4ZM64.1 73.6h5.4v10.8h-5.4Z" fill="none" stroke="' + INK +
      '" stroke-width="0.7" opacity="0.85"/>';

    /* masts: tapered lattice legs with the bracing punched out, lamp banks on top */
    masts.forEach(function (mx) {
      var lat = 'M' + r2(mx - 3.6) + ' 46.5L' + r2(mx - 1.5) + ' 21.8h3L' + r2(mx + 3.6) + ' 46.5Z';
      for (i = 0; i < 5; i++) {
        var dy = 25 + i * 4.6;
        lat += ' M' + r2(mx) + ' ' + r2(dy - 1.6) + 'L' + r2(mx + 0.95) + ' ' + r2(dy) +
          'L' + r2(mx) + ' ' + r2(dy + 1.6) + 'L' + r2(mx - 0.95) + ' ' + r2(dy) + 'Z';
      }
      o += '<path fill-rule="evenodd" fill="' + INK + '" d="' + lat + '"/>';
      var head = rr(mx - 8, 12.5, 16, 9.6, 1.4);
      for (i = 0; i < 6; i++) {
        head += ' ' + bar(mx - 6.5 + (i % 3) * 4.5, 14.4 + (i > 2 ? 3.8 : 0), 3.2, 2.8);
      }
      o += '<path fill-rule="evenodd" fill="' + INK + '" d="' + head + '"/>';
      o += '<path d="' + bar(mx - 9, 22.4, 18, 1.3) + '" fill="' + INK + '"/>';
    });

    for (i = 0; i < 14; i++) {                           // haze in the night sky
      o += '<circle cx="' + r2(rnd() * 100) + '" cy="' + r2(2 + rnd() * 40) + '" r="' +
        r2(0.45 + rnd() * 0.75) + '" fill="' + L1 + '" opacity="' + r2(0.2 + rnd() * 0.3) + '"/>';
    }
    o += '<path fill-rule="evenodd" fill="' + INK + '" d="M0 109H100V117H0Z ' +
      bar(12, 111.6, 44, 2.2) + ' ' + bar(60, 111.6, 28, 2.2) + '"/>';
    return o;
  };

  /* admission stub — perforation, torn foot, ruled rows, and a section/row/seat
     block left blank so the shine fills in the seat you were sold. */
  A.motif.ticket = function (seed) {
    var rnd = rng(seed || 'ticket'), o = '', i;

    /* the foot tears off: a ragged walk right→left, seeded so a reprint of the
       same seal tears along exactly the same line */
    var tear = '';
    for (i = 1; i <= 11; i++) {
      tear += 'L' + r2(89 - i * (78 / 11)) + ' ' + r2((i % 2 ? 111.4 : 105.2) + rnd() * 2.2);
    }
    var sil = 'M11 7H89V67A5 5 0 0 0 89 77V104' + tear + 'V77A5 5 0 0 0 11 67Z';
    o += cut([sil], INK, 0.45);

    /* the printed face stops above the tear, so the torn strip stays raw foil —
       the most damaged edge is the one that flashes hardest */
    var holes = [];
    holes.push(frame(20, 15, 60, 84, 1.1));            // foil keyline inside the border
    holes.push(rr(56, 17.5, 22, 9.5, 1.5));            // serial field
    holes.push(bar(22, 18.5, 32, 3.2));                // event rules
    holes.push(bar(22, 23.4, 24, 2.6));
    holes.push(bar(22, 30, 56, 3.4));
    holes.push(bar(22, 36.4, 40, 2.6));
    holes.push(rr(22, 42, 56, 7.4, 1.2));              // headline block
    holes.push(bar(24, 52.5, 52, 13));                 // barcode panel, ink bars land on it
    for (i = 0; i < 19; i++) holes.push(bar(23.5 + i * 2.9, 71.4, 1.7, 1.7));   // perforation
    holes.push(rr(23, 79, 54, 16, 1.2));               // SECTION / ROW / SEAT

    o += '<path fill-rule="evenodd" fill="' + INK +
      '" d="M14.5 10.5H85.5V68.5A3.5 3.5 0 0 0 85.5 75.5V102H14.5V75.5A3.5 3.5 0 0 0 14.5 68.5Z ' +
      holes.join(' ') + '"/>';
    o += '<path d="' + sil + '" fill="none" stroke="{{color_hex}}" stroke-width="1.5"/>';

    /* barcode: ink bars struck across the foil panel, widths from the seed */
    var bx = 26.5;
    while (bx < 73) {
      var bw = 0.7 + Math.floor(rnd() * 3) * 0.7;
      o += '<path d="' + bar(bx, 54, bw, 10) + '" fill="' + INK + '"/>';
      bx += bw + 0.8 + rnd() * 0.9;
    }
    o += '<path d="M26 65.6h48" stroke="' + INK + '" stroke-width="0.7" opacity="0.7"/>';

    /* stub block divided into three cells; each caption is inked, each VALUE is
       left as bare foil */
    o += '<path d="M41 79v16M59 79v16" stroke="' + INK + '" stroke-width="1.1"/>';
    [25, 43, 61].forEach(function (cx2, k) {
      o += '<path d="' + bar(cx2, 81, k === 1 ? 11 : 13, 2.4) + '" fill="' + INK + '"/>';
      o += '<path d="' + bar(cx2, 92, 9, 1.4) + '" fill="' + INK + '" opacity="0.75"/>';
    });
    o += '<rect x="56" y="17.5" width="22" height="9.5" rx="1.5" fill="none" stroke="' + INK +
      '" stroke-width="0.9"/>';
    o += '<path d="M22 51h56" stroke="' + INK + '" stroke-width="0.8" opacity="0.8"/>';

    /* perforation rule runs the full width, straight through the notch bites */
    o += '<path d="M15 72.25H85" stroke="{{color_hex}}" stroke-width="1" stroke-dasharray="3 2.6"/>';
    o += '<path d="M17 66.5A5.5 5.5 0 0 0 17 78M83 66.5A5.5 5.5 0 0 1 83 78" fill="none" stroke="' +
      INK + '" stroke-width="0.9" opacity="0.85"/>';
    o += '<path d="M20 15.6h60M20 98.4h60" stroke="' + L2 + '" stroke-width="0.5" opacity="0.5"/>';

    for (i = 0; i < 12; i++) {                          // paper fibre thrown off the tear
      o += '<circle cx="' + r2(13 + rnd() * 74) + '" cy="' + r2(104 + rnd() * 11) + '" r="' +
        r2(0.5 + rnd() * 0.9) + '" fill="' + L1 + '" opacity="' + r2(0.3 + rnd() * 0.4) + '"/>';
    }
    return o;
  };
})();
